<template>
  <div class="c-entryMv" :style="setStyleMv()">
    <picture>
      <source media="(max-width: 900px)" :srcset="imgsp" />
      <img :src="imgpc" :style="setStyleImg()" alt="" @load="imgloaded" />
    </picture>
  </div>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    props: ['imgpc', 'imgsp'],
    data() {
      return {
        assets_path: assets_path,
        styleMv: '',
        styleImg: '',
        preWidth: window.innerWidth,
        itemSize: {
          pc: {
            h: 745,
            w: 1680
          },
          sp: {
            h: 856,
            w: 750
          }
        }
      }
    },
    store,
    computed: {
      setStyleMv: function() {
        return function() {
          return this.styleMv;
        }
      },
      setStyleImg: function() {
        return function() {
          return this.styleImg;
        }
      }
    },
    created() {
    },
    mounted() {
      this.resize();
      window.addEventListener('resize', this.resize);
    },
    methods: {
      resize(e, isForce) {
        let imgW, imgH;
        let winW = this.$_getBodyWidth();
        let winH = window.innerHeight;

        if (window.innerWidth > breakpoint) {
          this.ispc = true;
          imgW = this.itemSize.pc.w;
          imgH = this.itemSize.pc.h;
          winH = winH * 0.8;
        } else {
          this.ispc = false;
          imgW = this.itemSize.sp.w;
          imgH = this.itemSize.sp.h;
          winH = winH * 0.8;
        }

        if (isForce === true || this.ispc || (!this.ispc && this.preWidth !== window.innerWidth)) {
          // ブラウザサイズにフィット
          const bgW = winW;
          const bgH = winH;
          const scale = Math.max(bgW / imgW, bgH / imgH);
          const frameW = imgW * scale;
          const frameH = imgH * scale;
          const frameX = (winW - frameW) / 2;
          const frameY = (winH - frameH) / 2;

          this.styleMv = `height:${winH}px;width:${winW}px`;
          this.styleImg = `height:${frameH}px; width:${frameW}px; left:${frameX}px; top:${frameY}px;`;
        }

        this.preWidth = window.innerWidth;
      },
      imgloaded(e) {
        if (window.innerWidth > breakpoint) {
          this.itemSize.pc.w = e.target.naturalWidth;
          this.itemSize.pc.h = e.target.naturalHeight;
        } else {
          this.itemSize.sp.w = e.target.naturalWidth;
          this.itemSize.sp.h = e.target.naturalHeight;
        }
        this.resize(undefined, true);
      }
    }
  }
</script>
